<template>
  <v-container id="reservation-reception-search-location-component">
    <c-card title="출발지 / 도착지 설정" class="mt-12">
      <v-row>
        <v-col cols="12" lg="4" class="pr-10 pl-5">
          <v-row class="mb-3">
            <v-radio-group dense row v-model="form.townLocationInfo"  @change="reqMapDrivingPath">
              <v-radio
                v-for="location in display.townLocationInfo"
                :key="location.value"
                :label="location.label"
                :value="location.value"
              >
              </v-radio>
            </v-radio-group>
            <v-menu
              v-if="display.suburbanFareType === 'suburban_fr_area'"
              transition="scale-transition"
              nudge-bottom="30"
              allow-overflow
              max-width="500px"
              max-height="300px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  append-icon="keyboard_arrow_down"
                  :value="getAreaText(form.suburban)"
                  dense readonly
                  :disabled = isEnableSuburban()
                  style="margin-top: 15px"
                />
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, index) in display.suburbanAreaFareTypes"
                    :key="index"
                    @click="form.suburban = item; ">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.area }}구간</v-list-item-title>
                    <v-list-item-subtitle>{{ item.areaDescription }}({{ item.fare }}원)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
          
          <v-row v-for="(point, index) in form.points" :key="index" style="margin-top: 20px">
            <v-col class="d-flex reverse pa-0">
              <v-menu
                v-model="point.showPositionList"
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="500px"
                max-height="300px">

                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    :label="setLabel(index)" clearable
                    v-model="point.positionText"
                    @keydown="checkPositionText(point, false, index, $event)"
                    @blur="checkPositionText(point, false, index, $event)"
                    @click:clear="pointReset(index)"
                    dense
                  ></v-text-field>
                </template>

                <v-list :hidden ="hiddenHomeAndRecentList(point)">
                  <v-list-item
                      v-for="(position, index) in display.homeAddressList.positionList"
                      :key="index"
                      dense
                      @click="onSelectedPosition(position, point)">
                    <v-list-item-icon>
                      <v-icon v-if="index == 0" color="yellow"> mdi-star </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.comment ? position.comment : '' }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-subheader>최근 이용 내역</v-subheader>
                  <v-list-item
                      v-for="(position, index) in display.recentPositionsList"
                      :key="index"
                      dense
                      @click="onSelectedPosition(position, point)">
                    <v-list-item-content>
                      <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-list :hidden ="hiddenHomeAndRecentList(point) == false">
                   <v-list-item
                      v-for="(position, index) in point.positionList"
                      :key="index"
                      dense
                      @click="onSelectedPosition(position, point)">
                    <v-list-item-content>
                      <v-list-item-title>{{ position.place_name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ position.address_name }}</v-list-item-subtitle>
                      <v-list-item-subtitle>{{ position.comment }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" v-if="point.addressText" class="mt-0 pt-0">
              <div>
                <v-icon>done</v-icon>
                <span class="font-weight-bold"> {{ point.addressText }}</span>
              </div>
            </v-col>
            <v-col cols="12" class="py-0 ml-3">
              <v-textarea
                rows="1"
                prepend-inner-icon="mode_comment"
                :label="setLabel(index) + ' 추가정보'"
                dense clearable outlined
                auto-grow hide-details
                v-model="point.comment"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center">
            <c-btn :disabled="display.disableWayPointAddBtn" color="blue" icon iconName="add" @click="onCalcWayPoints('+')"/>
            <c-btn :disabled="display.disableWayPointRemoveBtn" color="blue" icon iconName="remove" @click="onCalcWayPoints('-')"/>
          </v-row>
        </v-col>
        
        <v-col cols="12" lg="8">
          <v-row justify="end">
            <div v-if="form.totalTime" class="info-container">
              <span class="white--text subtitle-2"> 예상 주행 시간 : {{display.totalTime}}</span>
              <br/>
              <span class="white--text subtitle-2"> 예상 주행 거리 : {{display.totalDistance}} km</span>
              <br/>
              <span class="white--text subtitle-2"> 예상 주행 요금 : {{form.farePrice}} 원</span>
              <br/>
              <span class="white--text subtitle-2"> 예상 도움서비스 요금 : {{form.serviceFarePrice}} 원</span>
            </div>
            <naver-maps
              :width="map.width"
              :height="map.height"
              :mapOptions="map.mapOptions"
              :initLayers="map.initLayers"
              @load="onMapLoad">
            </naver-maps>
              <div v-for="(point, index) in form.points" :key="index" >
                <naver-marker v-if="point.selectedPosition"
                  :lng="parseFloat(point.selectedPosition.x)"
                  :lat="parseFloat(point.selectedPosition.y)"
                  @load="onMapMarkerLoaded"/>
              </div>
              <naver-polyline v-if="display.polyline"
                :path="display.polyline"
                @load="onMapPolylineLoaded"/>
          </v-row>
        </v-col>
      </v-row>
    </c-card>
  </v-container>
</template>

<script>
  export default {
    props: {
      reservationData : {
        type: Object
      },
      reservationRouteData: {
        type: Array
      },
      locationData: {
        type: Object
      },
      commentsData: {
        type: Object
      },
      customerData : {
        type: Array
      },
      fareInfo : {
        type: Object
      }
    },
    data: () => ({
      display : {
        townLocationInfo : [
          {label:'시내', value:'downTown'},
          {label:'시외', value:'suburbs'},
        ],
        totalTime: '',
        totalDistance: 0,
        fareType: '',
        suburbanAreaFareTypes : [],
        homeAddressList: {
          positionList:[]
        },
        recentPositionsList: [],
        disableWayPointAddBtn: false,
        disableWayPointRemoveBtn: true,
        pointsMaxCount:12,
        loadMapFlag: false,
        polyline: [],
        customerId: ''
      },

      form : {
        townLocationInfo : "downTown",
        suburban: '',
        points: [],
        fareType: '',
        suburbanFareType: '',
        suburbanAreaFareTypes: [],
        totalTime: '',
        totalDistance: 0,
        farePrice: 0,
        serviceFarePrice: 0,
        fareType: '',
        fareDetail:''
      },
      check:{
        selectedDate: '',
        selectedTime: ''
      },
      map: {
        width: 1100,
        height: 500,
        info: false,
        marker: null,
        count: 1,
        map: null,
        isCTT: false,

        mapOptions: {
          lat: 35.1348300,
          lng: 129.0830061,
          zoom: 13,
          zoomControl: true,
          zoomControlOptions: {position: 8},
          mapTypeControl: false ,
        },
        initLayers: ['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT'],
      },
      pathSearchIndex: 0
    }),
    async created() {
      await this.setMapViewInit()
      await this.getDefault()
    },

    watch: {
      'form': {
        deep: true,
        handler(val) {
          if(val) {
            let newLocationData = {}
            newLocationData.driveTime = this.form.totalTime
            newLocationData.driveDistance = this.form.totalDistance
            newLocationData._2UFare = this.form.farePrice
            newLocationData._2UServiceFare = this.form.serviceFarePrice
            newLocationData.suburban = this.form.townLocationInfo
            newLocationData.fareType = this.form.fareType
            newLocationData.fareDetail = this.form.fareDetail

            this.$emit('update:locationData', newLocationData)

            let seq = 0;
            let newReservationRouteData = []
            this.form.points.forEach( point => {
              if(point.selectedPosition) {
                if(point.selectedPosition.x && point.selectedPosition.y) {
                  newReservationRouteData.push({
                    position: point.addressText,
                    lat: point.selectedPosition.y,
                    lng: point.selectedPosition.x,
                    comment: point.comment,
                    seq: seq
                  })
                  seq ++
                }
              }
            })
            
            this.$emit('update:reservationRouteData', newReservationRouteData);
          }
        }
      },

      fareInfo: {
        deep: true,
        handler(val) {
          if (!!val.fareDetail) {
            const area = val.fareDetail.split('구간')[0];
            this.form.suburban = this.display.suburbanAreaFareTypes[parseInt(area)-1];
          }

          this.form.townLocationInfo = 'downTown';
          if (val.fareType.includes('suburban')) {
            this.form.townLocationInfo = 'suburbs';
          }
        }
      },
      customerData: {
        deep:true,
        handler(newVal) {
          if(newVal.length && newVal[0].id !== this.display.customerId) {
            this.display.customerId = newVal[0].id
            this.getHomeAddress()
            this.getRecentAddressList()
          }
        }
      },
      reservationData : {
        deep: true,
        handler(newVal, oldVal) {
          if(oldVal) {
            if(newVal.selectedDate !== this.check.selectedDate || newVal.selectedTime !== this.check.selectedTime) {
              this.check.selectedDate = newVal.selectedDate
              this.check.selectedTime = newVal.selectedTime
              this.reqMapDrivingPath()
            }
          }else {
            this.check.selectedDate = newVal.selectedDate
            this.check.selectedTime = newVal.selectedTime
          }
        }
      },
      'reservationData'() {
        if(this.reservationData.routePackage) {
          this.getReservationRoute(this.reservationData.routePackage);
        }
      },
      'form.suburban'() {
        this.reqMapDrivingPath()
      },
    },
    computed: {
      serviceTime() {
        if (!this.reservationData) return 0;
        return this.reservationData.selectedServiceTime < 0 ? this.reservationData.selectedServiceInput : this.reservationData.selectedServiceTime;
      },
    },
    methods: {
      setMapViewInit() {
        for(let i = 0; i < 3; i ++) {
          this.addPoint()
        }

        const centerPoint = this.$store.state.centerInfo.centerPoint;
        if (centerPoint !== null && centerPoint !== undefined) {
          let pointArray = centerPoint.split(',');
          if (this.map) {
            this.map.mapOptions.lng = pointArray[0];
            this.map.mapOptions.lat = pointArray[1];
          }
        }
      },
      addPoint() {
        this.form.points.push({
          positionText: '',
          positionList: [],
          selectedPosition: [],
          showPositionList: false,
          addressText: null,
          comment: ''
        })
      },
      async getDefault() {
        const centerId = this.$store.state.centerInfo.centerId;
        const { data:fareData } = await this.$api.getCenterInfoById(centerId);

        this.display.fareType = fareData.fareType ? fareData.fareType.configValue: '';
        this.display.suburbanFareType = fareData.fareType ? fareData.suburbanFareType.configValue: '';

        if (this.display.suburbanFareType.includes('area')) {
          const { data:suburbanAreaFares } = await this.$api.getSuburbanAreaFares(centerId, this.display.suburbanFareType);
          this.display.suburbanAreaFareTypes = suburbanAreaFares.sort((f1, f2) => f1.area - f2.area);

          if (!this.form.suburban) {
            this.form.suburban = this.display.suburbanAreaFareTypes[0]
          }
        }
        await this.reqMapDrivingPath();
      },
      async getReservationRoute(routePackage) {
        const reservationRoute = await this.$api.getReservationRoute(routePackage);

        if(reservationRoute.data.length > 0) {
          reservationRoute.data.forEach( (point, index) => {
            if( index > 2) this.addPoint()

            this.form.points[point.seq].positionText = point.position
            this.form.points[point.seq].selectedPosition = {x : point.lat, y : point.lng}
            this.form.points[point.seq].comment = point.comment
            
            let position = []
            const textArr = point.position.split('(')
            position['address_name'] = textArr[1] ? textArr[1].replace(')', '') : textArr[0]
            position['place_name'] = textArr[0]
            position['comment'] = point.comment
            position['x'] = point.lng
            position['y'] = point.lat
            
            this.onSelectedPosition(position, this.form.points[point.seq])
          })
        }
      },
      onMapLoad(vue) {
        this.map = vue;
        this.display.loadMapFlag = true;
      },
      createMarker(lat, lng) {
        return new naver.maps.Marker({
          position: new naver.maps.LatLng(lat, lng),
          map: null,
        });
      },
      onMapMarkerLoaded(vue) {
        vue.marker.setDraggable(false);
        vue.marker.setCursor('');
        vue.marker.setClickable(true);
      },
      onMapPolylineLoaded(vue) {
        if(vue) {
          vue.polyline.setOptions({strokeWeight: 3, strokeColor: 'blue'});
          this.display.polyline = vue;
        }
      },
      setLabel(index) {
        if(index === 0) return '출발지'
        else if(index === 1) return '도착지'
        else return '경유지' + (index - 1)
      },
      async getRecentAddressList() {
        //최근목록 불러오기
        if (this.customerData !== null && this.customerData.length > 0){
          this.display.recentPositionsList=[];

          const recentList = await this.$api.getRecentLocationList(this.customerData[0].id);
          for (let item of recentList.data) {
            let slashIdx = item.indexOf('/');
            let comment = item.substring(0, slashIdx);
            let text = item.substring(slashIdx + 1, item.indexOf('|'));
            let point = item.substring(item.indexOf('|')+1).split(',');

            let position = {};

            const textArr = text.split('(');

            position['place_name'] = textArr[0];
            position['address_name'] = textArr[textArr.length - 1].replace(')', '');
            position['comment'] = comment;
            position['x'] = point[1];
            position['y'] = point[0];

            //중복되는 내역들을 제거
            let previous = false;
            for(let i=0;i<this.display.recentPositionsList.length;i++) {
              if(this.display.recentPositionsList[i].place_name === position['place_name'] && this.display.recentPositionsList[i].address_name === position['address_name']) {
                if(this.display.recentPositionsList[i].comment === '' && position['comment'] !== '') this.display.recentPositionsList.splice(i, 1)
                else if(this.display.recentPositionsList[i].comment !== '' && position['comment'] === '') previous = true;
              }
            }
            if(!previous) this.display.recentPositionsList.push(position);
            previous = false;
          }
        }
      },
      checkPositionText(bind, isHomeAddress, index, event) {
        if (event.keyCode === 13) {
          this.onSetPosition(bind, isHomeAddress)
        }else {
          if (!bind.positionText) {
            this.pointReset(index)
            bind.showPositionList = true
          }
        }
      },
      async onSetPosition(bind, isHomeAddress) {
        // 주소-좌표 변환 객체 생성
        const geocoder = new kakao.maps.services.Geocoder();
        // 주소로 좌표 검색
        await geocoder.addressSearch(bind.positionText, (geoResult, geoStatus) => {
          const result = [];
          // 결과값 존재 시 [0] 번째 값만 추가
          if (geoStatus === kakao.maps.services.Status.OK) {
            result.push({
              address_name: geoResult[0].address_name,
              place_name: bind.positionText,
              comment: bind.positionTextDetail,
              x: geoResult[0].x,
              y: geoResult[0].y
            });
          }

          const userInfo = this.$store.state.userInfo.garagePoint; //"126.925468,37.523706"

          if (!isHomeAddress) {
            //장소 검색 객체 생성
            const ps = new kakao.maps.services.Places();
            //키워드로 장소 검색
            // CenterPoint 기준으로 리스트 출력
            ps.keywordSearch(bind.positionText, (data, searchStatus, pagination) => {
                  // 주소좌표, 키워드 장소 둘다 결과 값이 없을 경우
                  if (geoStatus !== kakao.maps.services.Status.OK && searchStatus !== kakao.maps.services.Status.OK) {
                    this.$store.commit('snackbar', {timeout: 2000, msg: '결과가 존재하지 않습니다.'});
                  }
                  // 결과값이 하나라도 존재 할 경우 menu list 출력
                  else {
                    bind.positionList = [...result, ...data];
                    bind.showPositionList = true;
                  }
                },
                {
                  x: userInfo.length > 0 ? userInfo.split(',')[0] : null, //longitude
                  y: userInfo.length > 0 ? userInfo.split(',')[1] : null //latitude
                });
          } else {
            bind.positionList = [...result];
            bind.showPositionList = true;
          }
        });
      },
      onSelectedPosition(position, bind) {
        const {x, y, address_name, place_name, comment} = position;
        bind.selectedPosition = position;
        bind.positionText = place_name;
        bind.addressText = place_name + '(' + address_name + ')';
        bind.comment = comment;

        if (this.map) {
          this.map.mapOptions.lat = y;
          this.map.mapOptions.lng = x;
          this.map.setCenter({y, _lat: y, x, _lng: x});
          this.map.setZoom(13, false);
        }
        if (bind.marker && Object.keys(bind.marker).length > 0) {
          bind.marker.setMap(null);
        }
        bind.marker = this.createMarker(y, x);
        //drivingPath 요청
        if (this.form.points[0].selectedPosition && this.form.points[1].selectedPosition) {
          this.reqMapDrivingPath();
        }
      },
      onCalcWayPoints(operator) {
        if (operator === '+') {
          this.addPoint()
        } else if (operator === '-') {
          const removedWayPoint = this.form.points.splice(this.form.points.length - 1)
          if (removedWayPoint[0].selectedPosition) {
            this.reqMapDrivingPath();
          }
        }

        this.display.disableWayPointAddBtn = this.form.points.length === this.display.pointsMaxCount ? true : false
        this.display.disableWayPointRemoveBtn = this.form.points.length < 4 ? true : false
      },
      hiddenHomeAndRecentList(point) {
        return point.positionList.length > 0 && point.positionText.length > 0 ? true : false
      },
      pointReset(index) {
        this.form.points[index].positionText = ''
        this.form.points[index].positionList = []
        this.form.points[index].selectedPosition = []
        this.form.points[index].showPositionList = false
        this.form.points[index].addressText = null
        this.form.points[index].comment = ''

        this.reqMapDrivingPath();
      },
      async getHomeAddress () {
        if (this.customerData !== null && this.customerData.length > 0) {
          this.display.homeAddressList = {
            positionList:[]
          };
          let address = '', addressDetails = '', addressLat = 0, addressLng = 0;
          if(typeof this.customerData[0].address === 'undefined') {
            let res;
            res = await this.$api.getCustomer(this.customerData[0].id)

            address = res.data.address;
            addressDetails = res.data.addressDetails;
            addressLat = res.data.addressLat;
            addressLng = res.data.addressLng;
          } else {
            address = this.customerData[0].address;
            addressDetails = this.customerData[0].addressDetails;
            addressLat = this.customerData[0].addressLat;
            addressLng = this.customerData[0].addressLng;
          }
          if(addressLat === 0 || addressLng === 0) {
            this.display.homeAddressList.positionText = address;
            this.display.homeAddressList.positionTextDetail = addressDetails;
            if (!!this.display.homeAddressList.positionText) {
              await this.onSetPosition(this.display.homeAddressList, true);
            }
          } else {

            let position = {}
            const addrArr = address.split('(')
            position['address_name'] = addrArr[0]
            position['place_name'] = addrArr[addrArr.length-1].replace(')', '')
            position['comment'] = addressDetails
            position['x']=addressLng
            position['y']=addressLat

            this.display.homeAddressList.positionList.push(position)
          }
        }
      },
      getAreaText(info) {
        return (!!info) ? `${info.area}구간 - ${info.areaDescription}(${info.fare}원)` : ''
      },

      isEnableSuburban() {
        return this.form.townLocationInfo !== 'suburbs';
      },
      async reqMapDrivingPath() {
        try {
          if (!!this.form.points[0].selectedPosition === false || !!this.form.points[1].selectedPosition === false) return

          if (Object.keys(this.form.points[0].selectedPosition).length === 0 || Object.keys(this.form.points[1].selectedPosition).length === 0) return

          if (isNaN(parseInt(this.serviceTime))) return;

          const startPoint = {
            name: "departure",
            lon: this.form.points[0].selectedPosition.x.toString(),
            lat: this.form.points[0].selectedPosition.y.toString()
          }
          const endPoint = {
            name: "destination",
            lon: this.form.points[1].selectedPosition.x.toString(),
            lat: this.form.points[1].selectedPosition.y.toString()
          }

          let wayPoints = []
          let waypointIndex = 0
          let before_lon = ''
          let before_lat = ''

          //빈값 체크 및 중복값 체크
          this.form.points.forEach( (wayPoint, index) => {
                        
            if(index < 2) return

            if(wayPoint.selectedPosition.x && wayPoint.selectedPosition.y) {
              let push = false

              let lon = wayPoint.selectedPosition.x.toString()
              let lat = wayPoint.selectedPosition.y.toString()

              if(!before_lon && !before_lat) {
                before_lon = wayPoint.selectedPosition.x.toString()
                before_lat = wayPoint.selectedPosition.y.toString()
                push = true
              }else {
                if( !(before_lon === lon && before_lat === lat) ){
                  push = true
                }
              }
              
              if(push) {
                waypointIndex++
                wayPoints.push({"name": waypointIndex, "lon": lon, "lat": lat})
                before_lon = lon
                before_lat = lat
              }
            }
          })

          if(wayPoints.length > 0 && wayPoints.length < 4) {
            wayPoints = this.checkOverlapLocation(startPoint, endPoint, wayPoints)
          }

          let paramWayPoint = []
          if (wayPoints.length > 0) {
            wayPoints.forEach( point => {
              paramWayPoint.push(`${point.lon},${point.lat}`)
            })
          }

          const params = {
            apiType: wayPoints.length > 3 ? 'tmap(다중 경유지)' : 'tmap',
            start: `${startPoint.lon},${startPoint.lat}`,
            end: `${endPoint.lon},${endPoint.lat}`,
            startTime: `${this.reservationData.selectedDate} ${this.reservationData.selectedTime}:00`,
            waypoints: paramWayPoint.join(":")
          }

          let fareType = this.form.townLocationInfo === 'downTown' ? this.form.fareType : this.form.suburbanFareType;
          const suburbanArea = fareType === 'suburban_fr_area' ? this.form.suburban.area : '';

          const param = `${JSON.stringify(params)}?serviceTime=${this.serviceTime}&fareType=${fareType}&suburbanArea=${suburbanArea}`;
          let pathSearchIndex = this.pathSearchIndex
          const res = await this.$api.getMapDrivingPath(param);

          // 마지막 처리 이후에 들어온 요청 결과에 대해 무시
          if (pathSearchIndex !== this.pathSearchIndex) {
            return;
          }

          this.display.totalTime = this.$func.msToTimeFormat(res.data.totalTimeMilisec)
          this.display.totalDistance = Number(res.data.totalDistanceMeter/1000).toFixed(3)
          this.form.totalTime = res.data.totalTimeMilisec
          this.form.driveDistance = res.data.totalDistanceMeter
          this.form.farePrice = res.data['2UFare']
          this.form.serviceFarePrice = res.data['2UServiceFare']
          
          let routesList = [];
          res.data.routes.forEach(item => {
            routesList.push({lat: item[1], lng: item[0]})
          })

          //경유지 없이 출발지 / 도착지 같을 경우 임의 데이터 처리
          if(wayPoints.length === 0 && startPoint.lon === endPoint.lon && startPoint.lat === endPoint.lat ) {
            routesList.push({lat: this.map.mapOptions.lat, lng: this.map.mapOptions.lon})
            this.form.totalTime = 1
          }

          if (this.display.polyline) {
            this.display.polyline.setVisible(true);
            this.display.polyline.setPath(routesList);
          }

          if (this.map) {
            try {
              let pathCenter = routesList[parseInt(routesList.length / 2)]

              this.map.setCenter({y: pathCenter.lat, _lat: pathCenter.lat, x: pathCenter.lng, _lng: pathCenter.lng})
              this.map.setZoom(13, true);
            } catch (e) {
              console.log(e)
            }
          }

          this.form.fareType = this.form.townLocationInfo === 'downTown' ? this.display.fareType : this.display.suburbanFareType
          this.form.fareDetail = ''
          if (this.form.townLocationInfo !== 'downTown' && fareType === 'suburban_fr_area') {
            // 시외이면서 구간요금제로 설정 된 경우 당시의 요금제 타입을 detail 에 저장한다.
            // 요금제가 변경되어도 예약당시의 요금제 기준으로 예약정보를 보기위함
            this.form.fareDetail = `${this.form.suburban.area}구간 - ${this.form.suburban.areaDescription}`
          }

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'SearchLocation/ reqDrivingPath', msg: '경로에 대한 결과가 없습니다.'})
        } finally {
          this.pathSearchIndex += 1
        }
      },
      checkOverlapLocation(start, end, way) {
        let checkWayPoints = []

        way.forEach( point => {
          let push = false
          if(point.name === 1) {
            if(point.name === way.length) {
              push = this.resultOverlapLocation(start, end, point)
            }else {
              push = this.resultOverlapLocation(start, way[1], point)
            }
          }else if(point.name === 2) {
            if(point.name === way.length) {
              push = this.resultOverlapLocation(way[0], end, point)
            }else {
              push = this.resultOverlapLocation(way[0], way[2], point)
            }
          }else if(point.name === 3) {
            push = this.resultOverlapLocation(way[1], end, point)
          }

          if(push) checkWayPoints.push(point)
        })

        return checkWayPoints
      },
      resultOverlapLocation(front, back, select) {
        if( !(front.lon === select.lon && front.lat === select.lat) && !(back.lon === select.lon && back.lat === select.lat) ) {
          return true
        }else {
          return false
        }
      },
      clearData() {
        this.form.totalTime = '';
        this.display.polyline.setVisible(false);
        this.getDefault();
        this.form.points.forEach((point, index) => {
          this.pointReset(index);
        })
      }
    }
  }
</script>

<style scoped>
  .info-window-container {
    padding: 10px;
    width: 300px;
    height: 100px;
  }
  .info-container {
    width: 250px;
    height: 110px;
    position: absolute;
    background-color: rgba(0,0,0,0.5);
    z-index: 5;
    padding: 10px;
  }
  .v-menu__content {
    z-index: 101 !important;
  }
</style>
